import ControllButton from './ControllButton';
import ICON_COMMENT_LIGHT from '../../../../public/static/viewer/icon-comment-light.svg';
import ICON_COMMENT from '../../../../public/static/viewer/icon-comment.svg';
import useTheme from '../../../common/hook/useTheme';

interface IProps {
  className?: string;
  disabled?: boolean;
  showShadow?: boolean;
  onClick: () => void;
}

export default function CommentButton({className, disabled, onClick}: IProps) {
  const {isLightMode} = useTheme();

  return (
    <ControllButton className={className} disabled={disabled} onClick={onClick}>
      <img
        src={isLightMode ? ICON_COMMENT_LIGHT : ICON_COMMENT}
        width={32}
        height={32}
        alt="comment"
      />
    </ControllButton>
  );
}
